<template>
  <div class="search-base search-container">
    <search-label-body :label="label" :label-hidden="labelHidden" :columns="options['gridTemplateColumns']">
      <template #afterLabel>
        <vs-checkbox :value="checkAll" @click.native="onCheckAll" />
      </template>
      <template>
        <div>
          <vs-select multiple class="w-full" style="min-width: 184px" autocomplete v-model="select" @input="input" @change="change">
            <vs-select-item v-for="(item, i) in items" :key="`${i}_${item}`" :text="getText(item)" :value="getValue(item)" />
          </vs-select>
        </div>
      </template>
    </search-label-body>
  </div>
</template>

<script>
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
export default {
  name: "SearchSelectMulti",
  components: {
    SearchLabelBody,
  },
  props: {
    label: String,
    value: Array,
    query: {
      type: Object,
      default: () => {
        return {
          s_sm: "",
        };
      },
    },
    options: Object,
  },
  watch: {
    value(value) {
      this.select = value;
      this.checkAll = value && value.length === this.items.length && this.items.length > 0;
    },
  },
  computed: {
    isMobile() {
      return !(this.$store.state.verticalNavMenuWidth === "default");
    },
    defaultValue() {
      return this.options && this.options["default"] ? this.options["default"] : "";
    },
    initData() {
      const defaultValue = this.defaultValue;
      const _query_keys = Object.keys(this.query);
      const query = this.$route.query;
      const select = query[_query_keys[0]];

      if (select) {
        try {
          return {
            select: select || defaultValue,
          };
        } catch (e) {}
      }
      return {
        select: defaultValue,
      };
    },
    items() {
      return this.options.list || [];
    },
    labelHidden() {
      return !(this.isMobile || this.label);
    },
  },
  data() {
    return {
      checkAll: false,
      select: this.value || [],
    };
  },
  created() {
    this.select = this.initData.select;
    if (this.select.length === this.items.length) this.checkAll = true;
    this.$emit("input", this.select);
  },
  methods: {
    onCheckAll() {
      this.checkAll = !this.checkAll;
      if (this.checkAll) {
        this.select = this.items.map((item) => item.value);
      } else {
        this.select = [];
      }
    },
    input(data) {
      this.$emit("select", data || this.defaultValue);
    },
    change(data) {
      this.$emit("input", data || this.defaultValue);
    },
    getText(item) {
      if (typeof item === "object") {
        return item.text;
      }
      return item;
    },
    getValue(item) {
      if (typeof item === "object") {
        return item.value;
      }
      return item;
    },
  },
};
</script>
